export const NOTIFICATIONS_CACHE_TTL = 60 * 60 * 1000;

const STORAGE_KEY = "portal.notifications.v1";

export function readNotificationsCache(contextKey) {
  try {
    const cached = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (
      cached && cached.contextKey === contextKey &&
      Array.isArray(cached.data) &&
      Number.isFinite(cached.fetchedAt) && cached.fetchedAt > 0 &&
      cached.fetchedAt <= Date.now()
    ) {
      return cached;
    }
  } catch {
    // The in-memory cache remains available if browser storage is unavailable.
  }
  return null;
}

export function writeNotificationsCache(cached) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cached));
  } catch {
    // Storage limits must not prevent notifications from being displayed.
  }
}

export function clearNotificationsCache() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Resetting the Vuex state still clears notifications from the interface.
  }
}
